<template>
    <v-inline-loader />
</template>

<script>
    import vInlineLoader from '@/components/v-inline-loader';
    import ConnectionWindow from './connection-window';

    // noinspection JSUnusedGlobalSymbols
    export default {
        components: {
            vInlineLoader,
        },
        props: {
            service: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                connectionWindow: new ConnectionWindow({window}),
            };
        },
        created() {
            this.connectionWindow.receiveResponse(this.$route.query);
        },
        beforeDestroy() {
            this.connectionWindow.close();
        },
    };
</script>
